import React from 'react';
import PropTypes from 'prop-types';
import style from './Leads.module.scss';

const ConnectivityChart = ({ callDetailsData }) => {
  const { missedCalls, receivedCalls, blacklistcalls } = callDetailsData;
  const totalCalls = missedCalls + receivedCalls + blacklistcalls;

  const data = [
    { name: 'Received calls', y: receivedCalls, color: '#90EE90' },
    { name: 'Missed by you', y: missedCalls, color: '#FF7F7F' },
    { name: 'Blacklist calls', y: blacklistcalls, color: '#C4A484' },
  ].filter((each) => each.y > 0);

  const receivedPercentage = (receivedCalls / totalCalls) * 100 || 0;
  const missedPercentage = (missedCalls / totalCalls) * 100 || 0;
  const blacklistPercentage = (blacklistcalls / totalCalls) * 100 || 0;

  const receivedStrokeLength = (receivedPercentage * 100) / 100;
  const missedStrokeLength = (missedPercentage * 100) / 100;
  const blacklistStrokeLength = (blacklistPercentage * 100) / 100;

  const receivedColor = '#90EE90';
  const missedColor = '#FF7F7F';
  const blacklistColor = '#C4A484';

  return (
    <>
      {totalCalls > 0 && (
        <div className="mt-10">
          <div className="text_center">
            <div className="font14 fw500 color111" style={{ textAlign: 'left' }}>
              Your past connectivity details
            </div>
            <div className="font13 fw400 color777">&nbsp;</div>
            <svg height="250" width="250" xmlns="http://www.w3.org/2000/svg">
              <circle
                cx="125"
                cy="125"
                r="100"
                strokeWidth="20"
                style={{ fill: 'none', stroke: 'rgb(228, 234, 239)' }}
              />
              {receivedCalls > 0 && (
                <>
                  <circle
                    cx="125"
                    cy="125"
                    r="100"
                    fill="none"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="20"
                    stroke={receivedColor}
                    pathLength="100"
                    strokeDasharray={`${receivedStrokeLength} ${100 - receivedStrokeLength}`}
                    strokeDashoffset="0"
                  />
                </>
              )}
              {missedCalls && (
                <circle
                  cx="125"
                  cy="125"
                  r="100"
                  fill="none"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="20"
                  stroke={missedColor}
                  pathLength="100"
                  strokeDasharray={`${missedStrokeLength} ${100 - missedStrokeLength}`}
                  strokeDashoffset={-`${receivedStrokeLength}`}
                />
              )}
              {blacklistcalls && (
                <circle
                  cx="125"
                  cy="125"
                  r="100"
                  fill="none"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="20"
                  stroke={blacklistColor}
                  pathLength="100"
                  strokeDasharray={`${blacklistStrokeLength} ${100 - blacklistStrokeLength}`}
                  strokeDashoffset={-`${receivedStrokeLength + missedStrokeLength}`}
                />
              )}
              <text
                x="50%"
                y="45%"
                dy=".3em"
                textAnchor="middle"
                style={{
                  fontSize: '32px',
                  fontWeight: 700,
                  fill: 'rgb(102, 102, 102)',
                }}
              >
                {totalCalls}
              </text>
              <text
                x="50%"
                y="60%"
                dy=".3em"
                textAnchor="middle"
                style={{ fontSize: '20px', fontWeight: 500, fill: 'rgb(74, 75, 77)' }}
              >
                Total Calls
              </text>
            </svg>
          </div>
          <div className={`${style.TabContent_Box} ml-30`}>
            {data.map((each, idx) => (
              <div key={idx} className={`${style.TabContent_LegndsRow}`}>
                <div className={`${style.TabContent_LegndsSquare}`} style={{ backgroundColor: each.color }} />
                <div className="font12 fw600 color777">{`${each.name}- ${each.y} `}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ConnectivityChart;

ConnectivityChart.propTypes = {
  callDetailsData: PropTypes.object,
};
